export default __webpack_public_path__ + "static/2288-b87aa48f4ca0fc1d5400c780e0ef7b17.gif";